import { useRef, useState } from 'react';

/**
 * Officer search for the Counter pane's header: a lens button, sitting left of A− / A+, that opens an inline
 * input. Typing filters/highlights the grid (HomeTab owns the text); the lens is tinted while a search is active.
 */
export function OfficerSearch({ value, onChange }: { value: string; onChange: (value: string) => void }) {
  const [open, setOpen] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const active = value !== '';
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, flexShrink: 0 }}>
      {open && (
        <span style={{ display: 'inline-flex', alignItems: 'center', background: 'white', border: '1px solid #93c5fd', borderRadius: 6, padding: '0 4px' }}>
          <input
            ref={inputRef}
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onBlur={() => setOpen(false)}
            placeholder="Search officer…"
            aria-label="Search officer"
            style={{ width: 130, fontSize: 12, border: 'none', outline: 'none', padding: '3px 2px', color: '#1e293b', background: 'transparent' }}
          />
          {active && (
            <button
              type="button"
              aria-label="Clear search"
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => { onChange(''); setOpen(false); }}
              style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8', fontSize: 13, lineHeight: 1, padding: '0 2px' }}
            >✕</button>
          )}
        </span>
      )}
      <button
        type="button"
        title="Search officer"
        aria-label="Search officer"
        onClick={() => { setOpen(true); requestAnimationFrame(() => inputRef.current?.focus()); }}
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2px 8px', borderRadius: 6, cursor: 'pointer',
          background: active ? '#dbeafe' : '#e0e7ff', border: `1px solid ${active ? '#60a5fa' : '#a5b4fc'}`,
          color: active ? '#1d4ed8' : '#3730a3', boxShadow: '0 1px 2px rgba(55,48,163,0.18)',
        }}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
          <circle cx="11" cy="11" r="7" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
      </button>
    </span>
  );
}
